// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.main {
  width: 90%;
  padding: 20px 10px;
  margin: 0px auto;
  margin-top: 4rem;
}

.greet-main {
  width: 90%;
  padding: 20px 10px;
  margin: 0px auto;
  margin-top: 2rem;
}

.greeting-main {
  display: flex;
}

.subTitle {
  color: #868e96 !important;
}

.greeting-main {
  display: flex;
}

.greeting-main > * {
  flex: 1 1;
  margin-bottom: 30px;
}

.button-greeting-div {
  display: flex;
  margin-top: 20px;
}

.greeting-text {
  font-size: 70px;
  line-height: 1.1;
  color: #000000 !important;
}

.greeting-text-p {
  font-size: 30px;
  line-height: 40px;
}

.greeting-image-div > img {
  max-width: 100%;
  height: auto;
}

.wave-emoji {
  animation-duration: 1.8s;
  animation-iteration-count: infinite;
  animation-name: wave;
  display: inline-block;
  transform-origin: 70% 70%;
}

@keyframes wave {
  0% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(-10deg);
  }
  20% {
    transform: rotate(12deg);
  }
  30% {
    transform: rotate(-10deg);
  }
  40% {
    transform: rotate(9deg);
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
/* Media Query */
@media (max-width: 1380px) {
  .greeting-text {
    font-size: 50px;
  }
  .greeting-text-p {
    font-size: 20px;
  }
}
@media (max-width: 768px) {
  .button-greeting-div {
    justify-content: space-around;
  }
  .greeting-text {
    font-size: 30px;
    text-align: center;
  }
  .greeting-text-p {
    font-size: 16px;
    line-height: normal;
    text-align: center;
  }
  .greeting-main {
    display: block;
  }
  .greeting-image-div {
    height: 256px;
  }
}
@media (max-width: 320px) {
  .main {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/containers/greeting/Greeting.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAEF;;AAAA;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,aAAA;AAGF;;AAAA;EACE,yBAAA;AAGF;;AAAA;EACE,aAAA;AAGF;;AAAA;EACE,SAAA;EACA,mBAAA;AAGF;;AADA;EACE,aAAA;EACA,gBAAA;AAIF;;AADA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;AAIF;;AADA;EACE,eAAA;EACA,iBAAA;AAIF;;AADA;EACE,eAAA;EACA,YAAA;AAIF;;AADA;EACE,wBAAA;EACA,mCAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;AAIF;;AADA;EACE;IACE,uBAAA;EAIF;EAFA;IACE,yBAAA;EAIF;EAFA;IACE,wBAAA;EAIF;EAFA;IACE,yBAAA;EAIF;EAFA;IACE,uBAAA;EAIF;EAFA;IACE,uBAAA;EAIF;EAFA;IACE,uBAAA;EAIF;AACF;AADA,gBAAA;AACA;EACE;IACE,eAAA;EAGF;EADA;IACE,eAAA;EAGF;AACF;AADA;EACE;IACE,6BAAA;EAGF;EADA;IACE,eAAA;IACA,kBAAA;EAGF;EADA;IACE,eAAA;IACA,mBAAA;IACA,kBAAA;EAGF;EADA;IACE,cAAA;EAGF;EADA;IACE,aAAA;EAGF;AACF;AAAA;EACE;IACE,WAAA;EAEF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.main {\n  width: 90%;\n  padding: 20px 10px;\n  margin: 0px auto;\n  margin-top: 4rem;\n}\n.greet-main {\n  width: 90%;\n  padding: 20px 10px;\n  margin: 0px auto;\n  margin-top: 2rem;\n}\n\n.greeting-main {\n  display: flex;\n}\n\n.subTitle {\n  color: $subTitle !important;\n}\n\n.greeting-main {\n  display: flex;\n}\n\n.greeting-main > * {\n  flex: 1;\n  margin-bottom: 30px;\n}\n.button-greeting-div {\n  display: flex;\n  margin-top: 20px;\n}\n\n.greeting-text {\n  font-size: 70px;\n  line-height: 1.1;\n  color: $textColor !important;\n}\n\n.greeting-text-p {\n  font-size: 30px;\n  line-height: 40px;\n}\n\n.greeting-image-div > img {\n  max-width: 100%;\n  height: auto;\n}\n\n.wave-emoji {\n  animation-duration: 1.8s;\n  animation-iteration-count: infinite;\n  animation-name: wave;\n  display: inline-block;\n  transform-origin: 70% 70%;\n}\n\n@keyframes wave {\n  0% {\n    transform: rotate(0deg);\n  }\n  10% {\n    transform: rotate(-10deg);\n  }\n  20% {\n    transform: rotate(12deg);\n  }\n  30% {\n    transform: rotate(-10deg);\n  }\n  40% {\n    transform: rotate(9deg);\n  }\n  50% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n/* Media Query */\n@media (max-width: 1380px) {\n  .greeting-text {\n    font-size: 50px;\n  }\n  .greeting-text-p {\n    font-size: 20px;\n  }\n}\n@media (max-width: 768px) {\n  .button-greeting-div {\n    justify-content: space-around;\n  }\n  .greeting-text {\n    font-size: 30px;\n    text-align: center;\n  }\n  .greeting-text-p {\n    font-size: 16px;\n    line-height: normal;\n    text-align: center;\n  }\n  .greeting-main {\n    display: block;\n  }\n  .greeting-image-div {\n    height: 256px;\n  }\n}\n\n@media (max-width: 320px) {\n  .main {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
